// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"filter-3"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 3L14.7365 9.2635L21 12L14.7365 14.7365L12 21L9.2635 14.7365L3 12L9.2635 9.2635L12 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 3L14.7365 9.2635L21 12L14.7365 14.7365L12 21L9.2635 14.7365L3 12L9.2635 9.2635L12 3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M21.125 4L21.1665 4.08346L21.25 4.125L21.1665 4.16654L21.125 4.25L21.0835 4.16654L21 4.125L21.0835 4.08346L21.125 4Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M19.75 18L20.3316 19.1684L21.5 19.75L20.3316 20.3316L19.75 21.5L19.1684 20.3316L18 19.75L19.1684 19.1684L19.75 18Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-filter-3')
export default class Filter3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-3',
    }
  }
}
